import { render, staticRenderFns } from "./secondStep.vue?vue&type=template&id=b9bbc20c&scoped=true"
import script from "./secondStep.vue?vue&type=script&lang=ts"
export * from "./secondStep.vue?vue&type=script&lang=ts"
import style0 from "./secondStep.vue?vue&type=style&index=0&id=b9bbc20c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bbc20c",
  null
  
)

export default component.exports